import { supabase } from "@/integrations/supabase/client";

export type PickAccessRow = {
  pick_id: string;
  can_access: boolean;
  access_reason: string;
  is_locked: boolean;
  is_free_pick: boolean;
  user_tier: string;
};

export async function fetchPickAccessMap(userId: string, start?: string, end?: string, onlyConcluded = false, top5Only = false, pickIds?: string[]) {
  // When explicit pickIds are provided, ignore the time window so picks whose
  // published_at falls outside [start,end] (e.g. slate-date based fetches where
  // a pick was published earlier than today's betting-day window) still get an
  // access row. Without this, the caller falls back to is_locked=true and even
  // admins/pros see a Pro Insight lock badge.
  const useWindow = !pickIds?.length;
  const { data, error } = await supabase.rpc("get_pick_access_rows", {
    _uid: userId,
    _start_ts: useWindow ? (start ?? null) : null,
    _end_ts: useWindow ? (end ?? null) : null,
    _only_concluded: onlyConcluded,
    _top5_only: top5Only,
  });
  if (error) throw error;
  const pickIdSet = pickIds?.length ? new Set(pickIds) : null;
  const rows = ((data ?? []) as PickAccessRow[]).filter((r) => !pickIdSet || pickIdSet.has(r.pick_id));
  return new Map(rows.map((r) => [r.pick_id, r]));
}

export async function fetchPickAccessForPick(userId: string, pickId: string) {
  const { data, error } = await supabase.rpc("get_pick_access_for_pick", {
    _uid: userId,
    _pick_id: pickId,
  });
  if (error) throw error;
  return ((data ?? [])[0] ?? null) as PickAccessRow | null;
}
